import { render, staticRenderFns } from "./TopThree.vue?vue&type=template&id=5144e938&scoped=true&"
import script from "./TopThree.vue?vue&type=script&lang=js&"
export * from "./TopThree.vue?vue&type=script&lang=js&"
import style0 from "./TopThree.vue?vue&type=style&index=0&id=5144e938&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5144e938",
  null
  
)

export default component.exports